/*
 * Zafari (2026-10-15): aplica solos los códigos del bundle "Llevá 2 / 3" (work/zafari-tema/scripts/zf-bundle-discounts.mjs):
 * por cada producto del carrito, con 3 unidades o más (sumando sus variantes) LLEVA3-<producto>, con 2 LLEVA2-<producto>.
 * Shopify permite 5 códigos de producto por pedido: se respetan primero los que haya puesto el cliente y después los del
 * bundle, del mayor ahorro al menor. Corre al cargar la página (carritos que vuelven) y en cada cartUpdate de Hyper; sólo
 * llama a /cart/update.js cuando el juego de códigos cambia, y re-dibuja el carrito con el mismo flujo que usa Hyper para
 * los cupones (sections + cartUpdate con zfSynced para no volver a entrar).
 */
(function () {
  'use strict';
  if (window.zfBundleSync) return;
  window.zfBundleSync = true;

  var PREFIX = 'LLEVA';
  var MAX_CODES = 5;
  var busy = false;
  var lastKey = null;

  function isOurs(code) {
    return typeof code === 'string' && code.indexOf(PREFIX) === 0;
  }

  // códigos del bundle que corresponden a este carrito, del mayor ahorro al menor
  function wanted(cart) {
    var qty = {};
    var price = {};
    (cart.items || []).forEach(function (i) {
      qty[i.product_id] = (qty[i.product_id] || 0) + i.quantity;
      price[i.product_id] = i.price;
    });
    var list = [];
    Object.keys(qty).forEach(function (pid) {
      var q = qty[pid];
      if (q >= 3) list.push({ code: PREFIX + '3-' + pid, save: q * price[pid] * 0.15 });
      else if (q === 2) list.push({ code: PREFIX + '2-' + pid, save: 2 * price[pid] * 0.1 });
    });
    list.sort(function (a, b) { return b.save - a.save; });
    return list.map(function (x) { return x.code; });
  }

  function keyOf(codes) {
    return codes.slice().sort().join(',');
  }

  function sync(cart) {
    if (busy || !cart || !window.FoxTheme) return;
    var current = (cart.discount_codes || []).map(function (d) { return d.code; });
    var others = current.filter(function (c) { return !isOurs(c); });
    var ours = wanted(cart).slice(0, Math.max(0, MAX_CODES - others.length));
    var next = others.concat(ours);
    var key = keyOf(next);
    if (key === keyOf(current) || key === lastKey) return;
    lastKey = key;
    busy = true;

    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
    var fd = new FormData();
    fd.append('sections', sections);
    fd.append('sections_url', window.location.pathname);
    fd.append('discount', next.join(','));

    fetch(FoxTheme.routes.cart_update_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (parsed) {
        // Hyper re-dibuja el carrito con cart.sections: sin secciones (ninguna parte del carrito en la página) no se publica
        if (!parsed || !parsed.sections) { busy = false; return; }
        return fetch(FoxTheme.routes.cart_url, FoxTheme.utils.fetchConfig()).then(function (r) { return r.json(); }).then(function (cartJson) {
          cartJson.sections = parsed.sections;
          busy = false;
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson, zfSynced: true });
        });
      })
      .catch(function () { busy = false; });
  }

  function start() {
    if (!window.FoxTheme || !FoxTheme.pubsub || !FoxTheme.routes) return setTimeout(start, 200);
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (ev && ev.cart && !ev.zfSynced) sync(ev.cart);
    });
    fetch(FoxTheme.routes.cart_url, FoxTheme.utils.fetchConfig())
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && c.item_count) sync(c); })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
